import { render, staticRenderFns } from "./DetailsNew.vue?vue&type=template&id=e3fc45b2&scoped=true"
import script from "./DetailsNew.vue?vue&type=script&lang=js"
export * from "./DetailsNew.vue?vue&type=script&lang=js"
import style0 from "./DetailsNew.vue?vue&type=style&index=0&id=e3fc45b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc45b2",
  null
  
)

export default component.exports